import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    btn: {
        backgroundColor: theme.palette.primary.main,
        margin: '0 16px',
    },
    btnText: {
        color: '#FFFFFF',
    },
}));
